"use client";

import Link from "next/link";
import Doodle from "./Doodle";
import ImageCarousel from "./ImageCarousel";
import { sectionFor, type HomepageProps } from "./types";
import { CarouselSkeleton, useLazyAssets } from "./useLazyAssets";

export default function GalleryPreviewSection({ data }: HomepageProps) {
  const section = sectionFor(data, "gallery_preview");
  const images = useLazyAssets("gallery");

  return (
    <section className="relative overflow-hidden bg-white px-6 pt-10 pb-28 lg:px-10">
      <Doodle type="flower" className="left-6 top-2 hidden md:block" size={100} />
      <Doodle type="flowersGrass" className="bottom-0 left-24 hidden lg:block" size={280} />
      <Doodle type="bee" className="bottom-4 right-20 hidden md:block" size={150} />
      <Doodle type="trailYellow" className="right-10 top-2 hidden md:block" size={70} />

      <h2 className="mx-auto mb-4 max-w-6xl text-center text-4xl font-extrabold text-[#ffc64a] md:text-6xl">
        {section.title || "Cherie Childminding GALLERY"}
      </h2>
      <div className="mx-auto h-5 max-w-7xl bg-[#08a997]" />
      <div className="mx-auto max-w-6xl py-8">
        {images === null ? (
          <CarouselSkeleton frameClassName="aspect-[4/3]" />
        ) : images.length === 0 ? (
          <p className="py-10 text-center text-2xl font-extrabold text-[#3d3835]">Photos coming soon!</p>
        ) : (
          <ImageCarousel images={images} visibleCount={3} frameClassName="aspect-[4/3]" />
        )}
      </div>
      <div className="mx-auto h-5 max-w-7xl bg-[#08a997]" />
      <div className="mt-8 text-center">
        <Link href={section.ctaHref || "/gallery"} className="inline-block border-2 border-black bg-[#08a997] px-8 py-2 text-2xl font-extrabold text-white shadow-[2px_2px_0_#2d2729]">
          {section.ctaLabel || "View More"}
        </Link>
      </div>
    </section>
  );
}
